import "./cart_detail.scss"

$(function () {
  /**
   * Prepne zobrazenie správy o veľkej váhe tovaru.
   * @param {boolean} isOverweight - Určuje, či váha košíku je cez limit.
   */
  function toggleOverweightMessage(isOverweight) {
    const alertElement = $("#alert-cart-overweight-error")

    if (isOverweight) {
      alertElement.show()
    } else {
      alertElement.hide()
    }
  }

  /**
   * Prepne zobrazenie správy o poštovnom zadarmo.
   * @param {boolean} isFree - Určuje, či je poštovné zadarmo.
   * @param {string} priceToFreeShippingStr - Zostávajúca suma do poštovného zdarma.
   */
  function toggleFreeShippingMessage(isFree, priceToFreeShippingStr) {
    const baseShippingMsgElement = $("#cart-base-shipping-msg")
    const notFreeShippingMsgElement = $("#cart-not-free-shipping-msg")
    const freeShippingMsgElement = $("#cart-free-shipping-msg")
    const priceToFreeShippingElement = $(
      "#cart-price-to-free-shipping",
      notFreeShippingMsgElement
    )
    const priceToFreeShipping = parseFloat(
      priceToFreeShippingStr.replace(",", ".")
    )

    if (isFree) {
      baseShippingMsgElement.hide()
      notFreeShippingMsgElement.hide()
      freeShippingMsgElement.show()
    } else if (priceToFreeShipping < 10) {
      priceToFreeShippingElement.text(priceToFreeShippingStr)
      baseShippingMsgElement.hide()
      notFreeShippingMsgElement.show()
      freeShippingMsgElement.hide()
    } else {
      baseShippingMsgElement.show()
      notFreeShippingMsgElement.hide()
      freeShippingMsgElement.hide()
    }
  }

  /**
   * Prepne zobrazenie správy o doprave zadarmo
   * pre určité spoločnosti.
   * @param {string[]} names - Názvy spoločností.
   */
  function togglePromoFreeShipping(names) {
    const wrapper = $("#cart-promo-free-delivery")
    const companyNamesEl = $("#cart-promo-free-delivery-company-names")

    if (names.length === 0) {
      wrapper.hide()
    } else {
      companyNamesEl.text(names.join(", "))
      wrapper.show()
    }
  }

  /**
   * Aktualizuje riadok so zľavou.
   * @param {string} discountEur - Výška zľavy v eurách.
   * @param {string} priceToDiscount - Za koľko ešte treba nakúpiť, aby bola aplikovaná zľava.
   */
  function updateDiscountRow(discountEur, priceToDiscount) {
    const discountEurElement = $("#discount-eur")
    const priceToDiscountElement = $("#price-to-discount")
    const hasDiscountRow = $(".cart-row-has-discount")
    const noDiscountRow = $("#no-discount")

    discountEurElement.text(discountEur)
    priceToDiscountElement.text(priceToDiscount)

    if (discountEur === "0,00") {
      hasDiscountRow.addClass("hidden")
      noDiscountRow.removeClass("hidden")
    } else {
      hasDiscountRow.removeClass("hidden")
      noDiscountRow.addClass("hidden")
    }
  }

  /**
   * Odstráni produkt z košíka.
   * @param {string} postData - Údaje, ktoré sa posielajú POST requestom.
   * @param {string} itemId - ID odstraňovanej položky v košíku.
   * @param {string} sku - SKU.
   */
  function removeFromCart(postData, itemId, sku) {
    /**
     * @param {object} data
     * @param {string} data.total_price_without_discount - Celková suma v košíku s DPH bez zľavy.
     * @param {string} data.total_price - Celkov suma v košíku s DPH.
     * @param {string} data.discount_eur - Výška zľavy v eurách.
     * @param {string} data.price_to_discount - Za koľko ešte treba nakúpiť, aby bola aplikovaná zľava.
     * @param {number} data.items_count - Počet položiek v košíku.
     * @param {boolean} data.overweight - Príznak, či nie je objednávka moc ťažká.
     * @param {string} data.free_shipping_price - Suma ktorá zostáva do poštovného zadarmo.
     * @param {boolean} data.is_free - Poštovné je zadarmo.
     * @param {number} data.quantity - Počet odstránených kusov.
     * @param {string} data.data_layer.brand
     * @param {string} data.data_layer.id
     * @param {string} data.data_layer.name
     * @param {string} data.data_layer.price
     * @param {number} data.data_layer.quantity
     * @param {string[]} data.promo_free_delivery_company_names - Zoznam dopravných spoločností, pre ktoré je poštovné zadarmo.
     */
    function successRemoveFromCart(data) {
      window.cart.updateCartInfo(
        data.total_price,
        data.total_price_without_discount,
        data.items_count
      )
      updateDiscountRow(data.discount_eur, data.price_to_discount)
      toggleFreeShippingMessage(data.is_free, data.free_shipping_price)
      toggleOverweightMessage(data.overweight)
      togglePromoFreeShipping(data.promo_free_delivery_company_names)
      window.cart.dataLayerAction("remove", "removeFromCart", data.data_layer)

      // Google Analytics 4
      const item = window.ga4.findItemData(sku)
      if (item != null) {
        item.quantity = data.quantity
        window.ga4.pushRemoveFromCart([item])
      }

      $("#cart-row-item-" + itemId).remove()

      // zobrazenie riadku informujúcom o prázdnom košíku
      if (data.items_count === 0) {
        document.getElementById("cart-empty-row").classList.remove("hidden")
      }
    }

    $.post(window.removeFromCartUrl, postData, successRemoveFromCart, "json")
  }

  /**
   * Odstránenie položky z košíka.
   */
  $(document).on("click", ".remove-from-cart", function (event) {
    const itemId = $(this).data("item-id")

    // Vypnutie tlačítka na odstránenie, kvôli prevencii dvojitého stlačenia.
    $(this).prop("disabled", true)

    removeFromCart(
      $.param({ item: itemId }),
      itemId,
      event.currentTarget.dataset.sku
    )
    event.preventDefault()
  })

  function showAlert(text, status) {
    const alertDiv = $("<div />")
      .addClass("alert alert-dismissible alert-" + status)
      .attr("role", "alert")
      .text(text)

    $("<button />")
      .addClass("close")
      .html('<span aria-hidden="true">×</span>')
      .attr({
        type: "button",
        "data-dismiss": "alert",
        "aria-label": "Zatvoriť",
      })
      .appendTo(alertDiv)

    $("#cart-content").prepend(alertDiv)
  }

  /**
   * Nastaví nové množstvo položky v košíku.
   * @param {string} itemId - ID nastavovanej položky.
   * @param {number} quantity - Nový počet kusov.
   * @param {string} sku - SKU.
   */
  function setItemQuantity(itemId, quantity, sku) {
    const postData = $.param({ item: itemId, quantity: quantity })

    /**
     * @param {object} data
     * @param {string} data.total_price - Celková suma v košíku s DPH.
     * @param {string} data.discount_eur - Výška zľavy v eurách.
     * @param {string} data.price_to_discount - Za koľko ešte treba nakúpiť, aby bola aplikovaná zľava.
     * @param {string} data.total_price_without_discount - Celková suma v košíku s DPH bez zľavy.
     * @param {number} data.item_quantity - Množstvo daného tovaru v košíku po aktualizácii.
     * @param {string} data.item_total_price - Celková cena daného tovaru v košíku po aktualizácii.
     * @param {string} data.free_shipping_price - Suma ktorá zostáva do poštovného zadarmo.
     * @param {boolean} data.is_free - Poštovné je zadarmo.
     * @param {boolean} data.overweight - Váha tovaru v košíku je vyššia ako je limit.
     * @param {number} data.item_quantity_diff - Rozdiel medzi pôvodným a aktuálnym množstvom tovaru.
     */
    function successSetProductQuantity(data) {
      if (quantity === data.item_quantity) {
        window.cart.updateCartInfo(
          data.total_price,
          data.total_price_without_discount
        )
        updateDiscountRow(data.discount_eur, data.price_to_discount)
        toggleFreeShippingMessage(data.is_free, data.free_shipping_price)
        toggleOverweightMessage(data.overweight)

        $("#price-cart-item-" + itemId).html(data.item_total_price)

        // Google Analytics 4
        const item = window.ga4.findItemData(sku)
        if (item != null) {
          item.quantity = Math.abs(data.item_quantity_diff)

          if (data.item_quantity_diff < 0) {
            window.ga4.pushAddToCart([item])
          }

          if (data.item_quantity_diff > 0) {
            window.ga4.pushRemoveFromCart([item])
          }
        }
      } else {
        $("#alert-out-of-stock").removeClass("hidden")
      }
    }

    $.post(window.setQuantityUrl, postData, successSetProductQuantity, "json")
  }

  /**
   * Aktualizácia množstva danej položky v košíku.
   */
  $(".spinner")
    .on("spin.bop.spinner", function (event, ui) {
      const itemId = $(this).data("item-pk")

      // ak spinner nemá nastavené ID položky, tak sa nič nenastavuje
      if (itemId !== undefined) {
        $("#alert-out-of-stock").addClass("hidden")

        $(this).parent().parent().find(".tg-stock-error").remove()
        $(this).parent().parent().find("br").remove()

        setItemQuantity(itemId, ui.value, $(this).data("sku"))
      }
    })
    .on("bounce-max.bop.spinner", function () {
      $("#alert-out-of-stock").removeClass("hidden")
    })

  /**
   * Validácia tovaru po kliku na "Objednať tovar".
   */
  $("#tg-cart-submit").click(function (event) {
    document
      .querySelectorAll(".alert.alert-dismissible")
      .forEach((el) => el.remove())
    document.querySelectorAll(".tg-stock-error").forEach((el) => el.remove())

    const emptyCart =
      parseInt(document.querySelector(".tg-menu-cart-quantity").textContent) ===
      0
    if (emptyCart) {
      event.preventDefault()
      showAlert("Košík je prázdny.", "danger")
      return
    }

    let allInStock = true

    $(".cart-item-quantity").each(function () {
      const quantity = parseInt($(this).val())
      const inStock = parseInt($(this).data("in-stock"))

      if (quantity > inStock) {
        $(this)
          .parent()
          .parent()
          .prepend(
            '<div class="tg-stock-error">Skladom len ' +
              inStock +
              " ks<br><br></div>"
          )
        allInStock = false
      }
    })

    if (!allInStock) {
      event.preventDefault()
      showAlert(
        "Ľutujeme, ale požadované množstvo niektorých položiek už nie je skladom. Prosím, upravte počet kusov.",
        "danger"
      )
    }
  })

  $(".upsell .add-to-cart").click(function () {
    window.location.href = window.cartDetailUrl
  })
})
